
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/redtrack-alternative",
      function () {
        return require("private-next-pages/redtrack-alternative.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/redtrack-alternative"])
      });
    }
  